import { translate } from '../common/helpers/translate.helper';

import type { DemandCalculation } from './types/DemandCalculation';
import type { DemandFleetChange } from './types/DemandFleetChange';
import { FleetChangeHandling } from './types/FleetChangeHandling';

export const getFleetChangeError = (change: DemandFleetChange, calculation?: DemandCalculation): string | undefined => {
    if (change.handling !== FleetChangeHandling.MIRROR_VESSEL) {
        return undefined;
    }

    if (calculation && !calculation.fleetChanges.addedVessels.some((vessel) => vessel.vesselId === change.vesselId)) {
        return undefined;
    }

    if (!change.mirrorVesselId || change.mirrorVesselId === change.vesselId) {
        return translate('demandDefinition.selectValidVesselToMirror');
    }

    if (
        calculation &&
        !calculation.vessels.some((vessel) => vessel.vesselId === change.mirrorVesselId && vessel.liftingCount > 0) &&
        !(calculation.vesselVolumes[change.mirrorVesselId] > 0)
    ) {
        return translate('demandDefinition.selectValidVesselToMirror');
    }

    return undefined;
};
